import { APPCONFG } from '@/constant/appConfig'
// 腾讯云IM APPID
export const APPID = APPCONFG(process.env.VUE_APP_MODE).APPID;
console.info(process.env.VUE_APP_MODE);
console.info(APPID);
// 腾讯云IM 创建的应用APP秘钥
export const APPSECRET = APPCONFG(process.env.VUE_APP_MODE).APPSECRET;

// 腾讯云IM 本地测试用户id
export const USERID = "100006547463";
export const JOINEDUSERID = "100006547483";


export const CALLTYPES = {
  '0,1': '平台端/物业APP',
  '0':"平台端", //0
  '1':"物业APP", //1-不可开门
  '2':"住户APP", //2-不可开门
  '3':"室内机", //3-不可开门
  '4':"单元机", //4-可开门
  '5':"围墙机", //5
}

